define.alias("ember-composable-helpers/helpers/optional", "settings/helpers/optional");